import { message } from 'ant-design-vue'
import Vue from 'vue'
import store from '@/store'
import { getLiveObjByScheduleId, checkLogin } from '@/api/live'
import { USER_INFO } from '@/store/mutation-types'
/**
 * 跳转到直播页面
 * @param {*} scheduleId 课次id，必传
 * @param {*} planclassesId 班级id，必传
 */
export async function goToLivePlayer(scheduleId = '', planclassesId = '') {
  const KEY = 'KEY' // message loading
  const nStuService = window.location.origin
  const userInfo = Vue.ls.get(USER_INFO) || store.state.user.userInfo
  console.log(userInfo)
  const formData = new FormData()
  formData.append('licenseCode', Vue.ls.get('code'))
  formData.append('wechatApplet', true)
  formData.append('telphone', userInfo.phoneNumber)
  formData.append('web', true)
  try {
    message.loading({ content: '跳转中...', key: KEY })
    const loginData = await checkLogin(formData)
    const res = await getLiveObjByScheduleId({ scheduleId })
    const { token, id: stuId } = loginData.student
    const { classesId, scene, pushType, channelId, status, scheduleType } = res
    const ocode = Vue.ls.get('code')
    if (scheduleType === '3') {
      toDirectBroadcast('videoBjy', nStuService, {
        scheduleId,
        planclassesId,
        classesId,
        stuId,
        ocode,
        token
      })
    } else {
      // 百家云直播
      if (status !== '2') {
        if (!channelId || status === '0') {
          message.warning({ content: '直播还未开始', key: KEY })
          return
        }
        toDirectBroadcast('watchLiveBjy', nStuService, {
          scheduleId,
          planclassesId,
          classesId,
          stuId,
          ocode,
          token
        })
        return
      } else {
        toDirectBroadcast('playbackBjy', nStuService, {
          scheduleId,
          planclassesId,
          classesId,
          stuId,
          ocode,
          token
        })
      }
    }
    // 阿里直播
    // if (pushType === '1') {
    //   toDirectBroadcast('watchLive', nStuService, {
    //     scheduleId,
    //     planclassesId,
    //     classesId,
    //     stuId,
    //     token
    //   })
    //   return
    // }
    // // 阿里三分屏直播
    // toDirectBroadcast('watchLive', nStuService, {
    //   scheduleId,
    //   planclassesId,
    //   classesId
    // })
  } catch (error) {
    console.error('Live jump', error)
  } finally {
    message.destroy({ key: KEY })
  }
  // checkLogin(formData).then(res => {
  //   console.log(res)
  //   const token = res.student.token
  //   const stuId = res.student.id
  //   // const localUser = {
  //   //   stuId: stuId,
  //   //   token: token
  //   // }
  //   res.student.stuId = res.student.id
  //   // res.student.photo && (res.student.photo = res.student.photo.split('51lss.com')[1])
  //   res.student.dataPath = 'https://static.51lss.com/data'
  //   Vue.ls.set('user', res.student)
  //   window.localStorage.setItem('user', JSON.stringify(res.student))
  //   console.log(res.student)
  //   getLiveObjByScheduleId({ scheduleId }).then(res => {
  //     if (res.pushType === '1' || !res.channelId) {
  //       // 阿里云直播
  //       // window.open(nStuService + '/watchLive/Index' + '?token=' + student.token + '&stuId=' + student.id + '&scheduleId=' + liveObj.scheduleId + '&planclassesId=' + this.planclassesId + '&classesId=' + liveObj.classesId)
  //       if (planclassesId === '0' || !planclassesId) {
  //         window.open(
  //           nStuService +
  //             '/watchLive/Index' +
  //             '?scheduleId=' +
  //             scheduleId +
  //             '&classesId=' +
  //             res.classesId +
  //             '&stuId=' +
  //             stuId +
  //             '&token=' +
  //             token
  //         )
  //       } else {
  //         window.open(
  //           nStuService +
  //             '/watchLive/Index' +
  //             '?scheduleId=' +
  //             scheduleId +
  //             '&planclassesId=' +
  //             planclassesId +
  //             '&classesId=' +
  //             res.classesId +
  //             '&stuId=' +
  //             stuId +
  //             '&token=' +
  //             token
  //         )
  //       }
  //       // }
  //     } else {
  //       if (res.scene === 'polyv_channel' || res.scene === 'ppt') {
  //         // 保利直播，
  //         // window.open(nStuService + '/watchLiveV2/Index' + '?token=' + student.token + '&stuId=' + student.id + '&scheduleId=' + liveObj.scheduleId + '&planclassesId=' + this.planclassesId + '&classesId=' + liveObj.classesId)
  //         if (planclassesId === '0' || !planclassesId) {
  //           window.open(
  //             nStuService +
  //               '/watchLiveV2/Index' +
  //               '?scheduleId=' +
  //               scheduleId +
  //               '&classesId=' +
  //               res.classesId +
  //               '&stuId=' +
  //               stuId +
  //               '&token=' +
  //               token
  //           )
  //         } else {
  //           window.open(
  //             nStuService +
  //               '/watchLiveV2/Index' +
  //               '?scheduleId=' +
  //               scheduleId +
  //               '&planclassesId=' +
  //               planclassesId +
  //               '&classesId=' +
  //               res.classesId +
  //               '&stuId=' +
  //               stuId +
  //               '&token=' +
  //               token
  //           )
  //         }
  //       } else {
  //         // 三分屏直播
  //         if (planclassesId === '0' || !planclassesId) {
  //           window.open(nStuService + '/watchLive/Index' + '&scheduleId=' + scheduleId + '&classesId=' + res.classesId)
  //         } else {
  //           window.open(
  //             nStuService +
  //               '/watchLive/Index' +
  //               '&scheduleId=' +
  //               scheduleId +
  //               '&planclassesId=' +
  //               planclassesId +
  //               '&classesId=' +
  //               res.classesId
  //           )
  //         }
  //         // window.open('/live/' + liveObj.scheduleId + '/' + this.planclassesId + '/' + liveObj.classesId)
  //       }
  //     }
  //   })
  // })

  // if (liveObj.openRecorde === 0) {
  //     message.error('直播未开放')
  //     return
  // }
  // const userInfo = store.state.user.userInfo
  // const orgInfo = store.state.system.orgInfo
  // console.log(orgInfo, userInfo)
  // const code = orgInfo.ocode
  // const params = {
  //     licenseCode: code,
  //     wechatApplet: true,
  //     telphone: userInfo.phoneNumber,
  //     web: true
  // }
  // let loginUrl = 'https://gateway.51lss.com/student/checkLogin'
  // loginUrl = transFormUrl(loginUrl)
  //  const nStuService = 'http://stu.51lss.com'
  //  const nStuService = window.location.origin
  //  https:// stu.51lss.com/watchLive/Index?classesId=6c581bc362f859cfa70098a85c9fddc1&planclassesId=1375ff50401df0e76f05dac1ad844d6a&scheduleId=ef5eb273c5959bf172894df73a23bb5b&stuId=189d080ecc06475fd4033b7e39851f1a

  // this.http.postH(loginUrl, params, false, true).subscribe(
  //     result => {
  //         console.log(result)
  //         const student = result.data.student
  //         if (liveObj.pushType === '1' || !liveObj.plChannelId) {
  //             // 阿里云直播
  //             window.open(nStuService + '/watchLive/Index' + '?token=' + student.token + '&stuId=' + student.id + '&scheduleId=' + liveObj.scheduleId + '&planclassesId=' + this.planclassesId + '&classesId=' + liveObj.classesId)
  //             // }
  //         } else {
  //             if (liveObj.scene === 'polyv_channel') {
  //                 // 保利直播，
  //                 window.open(nStuService + '/watchLiveV2/Index' + '?token=' + student.token + '&stuId=' + student.id + '&scheduleId=' + liveObj.scheduleId + '&planclassesId=' + this.planclassesId + '&classesId=' + liveObj.classesId)
  //             } else {
  //                 // 三分屏直播
  //                 window.open('/live/' + liveObj.scheduleId + '/' + this.planclassesId + '/' + liveObj.classesId)
  //             }
  //         }
  //     }, error => {
  //       console.log(error)
  //     }
  // )
}
// 拼接url并跳转
const toDirectBroadcast = (type, nStuService, data = {}) => {
  const url = `${nStuService}/${type}/Index?${joinData(data)}`
  // console.log(url)
  window.open(url)
}
// 拼接传递得数据 { id: 1, age: 2 } => id=1&age=2
const joinData = (obj = {}) => {
  const keys = Object.keys(obj)
  if (!keys.length) return ''
  return keys
    .reduce((result, key) => {
      const value = obj[key]
      if (!value || value === '0') {
        return result
      }
      result.push(`${key}=${obj[key]}`)
      return result
    }, [])
    .join('&')
}

// const checkLoginAsync = async (formData) => {
//   checkLogin(formData)
// }
// function transFormUrl(url) {
//   const domain51lss = '51lss.com'
//   const domainKuaijisishu = 'kuaijisishu.com'
//   if (window.location.href.indexOf(domainKuaijisishu) > -1) {
//     return url.replace(domain51lss, domainKuaijisishu)
//   }
//   return url
// }
